<div class="form-group search position-relative d-flex align-items-center my-5">
    <div class="col-auto px-2 py-0 ">
        <button type="submit" class="btn btn-search bold d-flex p-1">
            <span class="ic-">search</span>
        </button>
    </div>
    <div class="col p-0">
        <label for="searchHome" class="sr-only">Your spiritual experience today</label>
        <input [(ngModel)]="value" (blur)="onBlur()" type="text" class="form-control border-0 p-0" id="searchHome"
            placeholder="Your spiritual experience today" role="search">
        <button (click)="clearSearch()" type="button" class="btn btn-clear regular position-absolute d-flex align-items-center p-1">
            <span class="ic-">close</span>
        </button>
    </div>
</div>
